import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TGetCancelAffectedTransactionAPIParams } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { GoldSilverTypeEnum, GoldTypeEnum, MetalTypeEnum, SilverTypeEnum, TransactionActionEnum, TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetCancelAffectedTransaction(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetCancelAffectedTransactionAttempt', handleGetCancelAffectedTransaction, api);
}

function* handleGetCancelAffectedTransaction(api: GoldGateway, action: PayloadAction<{ transactionId: number }>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const transactionId = action.payload.transactionId;

    const response = yield* call([api, api.getCancelAffectedTransactionListing], {
        authToken,
        transactionId
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetCancelAffectedTransactionFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetCancelAffectedTransactionSuccess(response.data));

        const hasAffectedTransactions = response.data.data.length > 0;

        if (hasAffectedTransactions) {
            yield put(combinedActions.goldSetConfirmUpdateCancelTransactionModalIsOpen(true));
            
        } else {
            yield put(combinedActions.goldSetConfirmUpdateTransactionStatusModalIsOpen(true));

        }
    }
}
